import { render, staticRenderFns } from "./CategoryConfiguratorImages.vue?vue&type=template&id=7f227a7a&"
import script from "./CategoryConfiguratorImages.vue?vue&type=script&lang=js&"
export * from "./CategoryConfiguratorImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports